import React, { useEffect } from "react";
import Modal from "../Modal";

const getModalWidth = () => {
  if (window.innerWidth >= 768) {
    return "50%";
  } else {
    return "90%";
  }
};

const CustomModal = ({ isOpen, onRequestClose, contentLabel, children, contentClassName }) => {
  useEffect(() => {
    const updateWidth = () => {
      const modalContent = document.querySelector(".ReactModal__Content");
      if (modalContent) {
        modalContent.style.width = getModalWidth();
      }
    };

    window.addEventListener("resize", updateWidth);

    // Initial call to set width
    if (isOpen) {
      updateWidth();
    }

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={contentLabel}
      className={contentClassName}
      style={{
        content: {
          position: "fixed",
          top: "50vh",
          left: "50vw",
          right: "auto",
          bottom: "auto",
          marginRight: 0,
          transform: "translate(-50%, -50%)",
          backgroundColor: "#401a6e",
          width: getModalWidth(),
          maxHeight: "90vh",
          overflowY: "auto",
          overflowX: "hidden",
          WebkitOverflowScrolling: "touch",
          touchAction: "pan-y",
          margin: 0,
          padding: 0,
          /* Above wallet/XP history portals (10060) and ShopDrawer (10002) —
           * shop buy (HardOffers / SoftOffers) opens from inside that portal. */
          zIndex: 10071,
        },
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(11, 2, 18, 0.8)",
          zIndex: 10070,
        },
      }}
      ariaHideApp={false}
    >
      <div>{children}</div>
    </Modal>
  );
};

export default CustomModal;
